const personalDataPolicyUrl = `${process.env.PUBLIC_URL}/assets/documents/politika-obrabotki-personalnih-dannih.pdf`;

function Footer() {
    return (
        <footer className="footer">
            <span>© Трак-Центр 24</span>
            <a href={personalDataPolicyUrl} target="_blank" rel="noopener noreferrer">
                Политика в отношении обработки персональных данных
            </a>
        </footer>
    );
}

export default Footer;
